export default __webpack_public_path__ + "static/media/Arch_AWS-Certificate-Manager_64.a1f2096c.svg";